import { useTranslation } from 'react-i18next';

const useTranslationText = () => {
  const { t } = useTranslation();

  const translation = (key: string): string => t(key);

  return [translation];
};

export default useTranslationText;
